import React, { FC, useEffect } from 'react';
import { sendRestrictedModalAnalytics } from './restrictedModalAnalytics';
import styles from './restricted_modal_layout.module.scss';

type Props = {
  closeModal: () => void;
  source: string;
};

export const RestrictedModalLayout: FC<Props> = ({
  source,
  closeModal,
  children,
}) => {
  useEffect(() => {
    sendRestrictedModalAnalytics(source);
  }, [source]);

  return (
    <>
      <div className="small-modal__header">
        <button type="button" onClick={closeModal}>
          <i className="material-icons icons__close small-modal__close" />
        </button>
      </div>
      <div className={styles.content}>{children}</div>
    </>
  );
};
